import { renderUmamiGlobe } from "./index";

export { renderUmamiGlobe };
export type { UmamiGlobeOptions, UmamiGlobeInstance, GlobeData } from "./index";

/**
 * Self-mounting <script> entry.
 *
 * ```html
 * <script
 *   src="https://unpkg.com/umami-maps/dist/embed.global.js"
 *   data-endpoint="/api/visitor-globe"
 *   data-size="250"
 *   data-dark="false"
 *   data-target="#visitor-globe"
 * ></script>
 * ```
 *
 * Without `data-target`, the globe is inserted right where the script tag sits.
 */
function autoMount() {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script) return;

  const ds = script.dataset;
  let container: HTMLElement | null = null;

  if (ds.target) {
    container = document.querySelector<HTMLElement>(ds.target);
  } else {
    container = document.createElement("div");
    script.parentNode?.insertBefore(container, script);
  }
  if (!container) return;

  const mount = () =>
    renderUmamiGlobe(container as HTMLElement, {
      endpoint: ds.endpoint,
      size: ds.size ? Number(ds.size) : undefined,
      dark: ds.dark === "true",
      rotateSpeed: ds.rotateSpeed ? Number(ds.rotateSpeed) : undefined,
      caption: ds.caption !== "false",
    });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount, { once: true });
  } else {
    mount();
  }
}

autoMount();
